var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.5905C15 15.8184 15.4602 15.1351 16.0867 14.6838C17.8512 13.4129 19 11.3406 19 9C19 5.13401 15.866 2 12 2C8.13401 2 5 5.13401 5 9C5 11.3406 6.14878 13.4129 7.91327 14.6838C8.53977 15.1351 9 15.8184 9 16.5905V17C9 17.5523 9.44772 18 10 18H14C14.5523 18 15 17.5523 15 17V16.5905ZM9.76283 11.7885C10.1558 11.6575 10.5805 11.8699 10.7115 12.2628L10.7372 12.3398C10.9184 12.8834 11.427 13.25 12 13.25C12.573 13.25 13.0816 12.8834 13.2628 12.3398L13.2885 12.2628C13.4195 11.8699 13.8442 11.6575 14.2372 11.7885C14.6301 11.9195 14.8425 12.3442 14.7115 12.7372L14.6859 12.8141C14.382 13.7256 13.6453 14.4031 12.75 14.6491V16C12.75 16.4142 12.4142 16.75 12 16.75C11.5858 16.75 11.25 16.4142 11.25 16V14.6491C10.3547 14.4031 9.61795 13.7256 9.31415 12.8141L9.28849 12.7372C9.1575 12.3442 9.36987 11.9195 9.76283 11.7885Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 19.5C9.25 19.0858 9.58579 18.75 10 18.75H14C14.4142 18.75 14.75 19.0858 14.75 19.5C14.75 19.9142 14.4142 20.25 14 20.25H10C9.58579 20.25 9.25 19.9142 9.25 19.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 22C10.25 21.5858 10.5858 21.25 11 21.25H13C13.4142 21.25 13.75 21.5858 13.75 22C13.75 22.4142 13.4142 22.75 13 22.75H11C10.5858 22.75 10.25 22.4142 10.25 22Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.9324ae946b572e963abdb55bf1a38b7b.svg";
export { ForwardRef as ReactComponent };